<template>
    <div>
        <b-table bordered :fields="fields" :items="data.data">
            <template v-slot:cell(price)="{ item }">
                {{ item.price | currency }}
            </template>
            <template v-slot:cell(actions)="{ item }">
                <b-button variant="primary" @click="toAssign(item)"
                    ><i class="fa fa-check" aria-hidden="true"></i>
                    Asignar</b-button
                >
            </template>
        </b-table>
        <app-paginator
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        />
    </div>
</template>
<script>
import fields from './fields'
import Paginator from '../../../UI/Controls/Paginator/Paginator.vue'
export default {
    components: {
        appPaginator: Paginator,
    },
    data() {
        return {
            fields: fields,
        }
    },
    props: {
        data: {
            required: true,
        },
        toAssign: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
}
</script>
